export const SOCKET_MESSAGES = {
  CONNECTED: 'connect',
  DISCONNECTED: 'disconnect',
  RECONNECTED: 'reconnect',
  RECONNECT: 'reconnect_attempt',

  ERROR_CONNECT: 'connect_error',
  ERROR_DISCONNECT: 'disconnect_error',
  ERROR_RECONNECT: 'reconnect_error',

  GRID_SIZE: 'GRID_SIZE',
  UPDATE_GRID_SIZE: 'UPDATE_GRID_SIZE',

  ALL_MACHINES: 'ALL_MACHINES',
  AUTHENTICATE: 'AUTHENTICATE',
  DISCONNECTED_MACHINE: 'DISCONNECTED_MACHINE',
  UPDATE_CONFIG: 'updateMachineConfig',
  UPDATE_GRID_COORDS: 'UPDATE_GRID_COORDS',
  SENSOR_STATE: 'SENSOR_STATE',
  MACHINE_STATE: 'machineState',

  LOGIN_BY_RMS: 'LOGIN_BY_RMS',
  LOGOUT_BY_RMS: 'LOGOUT_BY_RMS',

  START_PRACTICE: 'START_PRACTICE',
  END_PRACTICE: 'END_PRACTICE',
  ADD_TIME: 'ADD_TIME',
  CHANGE_SEAT: 'CHANGE_SEAT',

  GET_WAITINGS: 'ALL_WAITINGS',
  ADD_WAITING: 'ADD_WAITING',
  REMOVE_WAITING: 'REM_WAITING',

  SERVER_TIME: 'SERVER_TIME',
  REFRESH_LOGIN_CODE: 'REFRESH_LOGIN_CODE',

  SMART_LOGIN_STATE: 'SMART_LOGIN_STATE',
}
